// extracted by mini-css-extract-plugin
export default {"empty-data":"style_empty-data__4lv7A","total":"style_total__kDFLN"};